module.exports = __webpack_public_path__ + "img/mycoupon_ico_Expired.aed98efb.png";